import { createContext, useState } from "react";
export const CountriesContext=createContext();
export function CountriesProvider({children}){
    const [s,sets]=useState("")
    return  <CountriesContext.Provider value={{s,sets}}>
   {children}
    </CountriesContext.Provider>

}